<template>
  <v-app>
    <v-main>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'App',
  computed: {
    ...mapState({
      isLogin: state => state.user.isLogin
    })
  },
  data: () => ({
    //
  })
}
</script>

<style lang="scss" scoped>
@import "assets/css/app";
</style>
